'use strict';
module.exports = require('./OrganizationChart.vue');